<template>
  <div ref="container">
    <div
      v-if="overlayValue"
      class="modal-drop-recu"
      :style="{ padding: modalPadding + 'vh 0' }"
      @click="checkOutside"
    >
      <div class="row dismiss-modal">
        <div class="flex md12 dismiss-modal">
          <va-card
            class="modal-container dismiss-modal"
            :style="{ width: modalWidth + 'vw', height: modalHeight + 'vh' }"
          >
            <div
              v-if="title"
              class="mb-4 title"
              :style="{ color: this.$themes.primary }"
            >
              {{ title }}
            </div>

            <div
              class="row row-inside"
              :style="{ height: modalHeight * 0.85 + 'vh' }"
            >
              <div
                class="flex md12 pa-0 ma-0"
                v-if="paiement && paiement.idpaiement_type === 6"
              >
                <va-tabs grow v-model="tabsState">
                  <va-tab v-if="prelevements.length > 0"
                    >Trimestre 1 -
                    {{
                      moment(prelevements[0].date_effectif).format("DD/MM/YYYY")
                    }}</va-tab
                  >
                  <va-tab v-if="prelevements.length > 1"
                    >Trimestre 2 -
                    {{
                      moment(prelevements[1].date_effectif).format("DD/MM/YYYY")
                    }}</va-tab
                  >
                  <va-tab v-if="prelevements.length > 2"
                    >Trimestre 3 -
                    {{
                      moment(prelevements[2].date_effectif).format("DD/MM/YYYY")
                    }}</va-tab
                  >
                  <va-tab v-if="prelevements.length > 3"
                    >Trimestre 4 -
                    {{
                      moment(prelevements[3].date_effectif).format("DD/MM/YYYY")
                    }}</va-tab
                  >
                  <va-tab v-if="obsolete">Obsolète</va-tab>
                </va-tabs>
              </div>
              <div class="flex md6">
                <div class="row row-inside">
                  <div class="flex md12">
                    <va-button
                      :disabled="disableActions || disableEmail"
                      class="fullwidth"
                      color="info"
                      @click="sendByEmail"
                      >Envoyer le reçu par mail</va-button
                    >
                  </div>
                  <div class="flex md12">
                    <va-button
                      class="fullwidth"
                      color="info"
                      :disabled="disableActions"
                      @click="openNewTab"
                      >Ouvrir le reçu dans un nouvel onglet</va-button
                    >
                  </div>
                  <div class="flex md12">
                    <va-button
                      class="fullwidth"
                      color="info"
                      :disabled="disableActions"
                      @click="downloadReceipt"
                      >Télécharger le reçu</va-button
                    >
                  </div>
                  <div class="flex md12 mt-2 fullsize">
                    <h4
                      class="fullwidth mb-3"
                      style="position: relative; top: 0.5em"
                    >
                      Actions:
                    </h4>

                    <div class="row" v-if="actionsHistoryFiltered.length < 1">
                      <div class="flex md12 mt-3">
                        <p class="text--secondary">Aucune actions</p>
                      </div>
                    </div>
                    <div
                      class="row actions-container"
                      v-if="actionsHistoryFiltered.length > 0"
                      :style="{ height: modalHeight * 0.5 + 'vh' }"
                    >
                      <div class="flex md12">
                        <template v-for="action in actionsHistoryFiltered">
                          <div class="row pb-2 px-2">
                            <div class="flex md12 text-lighter">
                              Reçu d'adhésion
                              <b>{{ methodType[action.communication_type] }}</b>
                              le
                              <b>{{
                                moment(action.date_creation).format(
                                  "DD/MM/YYYY"
                                )
                              }}</b>
                              par
                              <b>{{ action.prenom }} {{ action.nom }}</b>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex md6">
                <iframe
                  id="iframeRecu"
                  ref="iframeRecu"
                  v-if="pdfurl"
                  class="fullsize"
                  :src="pdfurl"
                />
                <div
                  class="solid fullsize"
                  @click="displayReceipt"
                  v-if="!pdfurl"
                >
                  <va-icon
                    class="center-icon"
                    name="fa fa-eye"
                    color="info"
                    size="5em"
                  />
                </div>
              </div>
            </div>
          </va-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
// todo Recu management is poluted by obsolete database state. Lots of hacks, this module should be rewritten
export default {
  name: "recuManager",
  props: {
    value: {
      required: true,
      default: false,
    },
    idadhesion: {
      required: true,
      default: null,
    },

    title: {
      required: false,
    },
    trimestreStart: {
      required: false,
    },
  },
  data() {
    return {
      moment: moment,
      modalWidth: 60,
      modalHeight: 80,
      file: [],
      overlayValue: false,
      pdfurl: "",
      disableActions: false,
      methodType: ["", "envoyé par mail", "imprimé", "téléchargé"],
      actionsHistory: [],
      adhesion: null,
      paiement: null,
      prelevements: [],
      tabsState: 0,
      obsolete: false,
      emails: null,
    };
  },
  mounted() {
    document.body.appendChild(this.$refs.container);
  },
  computed: {
    disableEmail() {
      let disable = false;
      this.actionsHistoryFiltered.forEach((element) => {
        console.log("test element", element);
        if (
          moment(element.date_creation).isSameOrAfter(
            moment().format("YYYY-MM-DD")
          ) &&
          element.communication_type === 1
        ) {
          disable = true;
        }
      });

      if (
        !this.emails ||
        (!this.emails.contact_email && !this.emails.entreprise_email)
      ) {
        disable = true;
      }
      return disable;
    },
    isMultiplePrelevement() {
      if (this.paiement && this.paiement.idpaiement_type === 6) {
        return true;
      } else {
        return false;
      }
    },
    actionsHistoryFiltered() {
      if (this.isMultiplePrelevement) {
        return this.actionsHistory.filter((item) => {
          let boolcond = false;
          if (this.prelevements[this.tabsState]) {
            if (
              item.idprelevement ===
              this.prelevements[this.tabsState].idprelevement
            ) {
              boolcond = true;
            } else {
              boolcond = false;
            }
          } else if (item.idprelevement === null) {
            boolcond = true;
          }
          console.log(item);
          return boolcond;
        });
      } else {
        return this.actionsHistory;
      }
    },
    modalPadding() {
      let halfHeight = 100 - this.modalHeight;
      return halfHeight / 2;
    },
    valueProxy: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    tabsState() {
      this.pdfurl = "";
    },
    value(value) {
      if (value) {
        this.overlayValue = true;
        window.addEventListener("keyup", this.listenKeyUp);
      } else {
        this.overlayValue = false;
        window.removeEventListener("keyup", this.listenKeyUp);
        this.pdfurl = "";
      }
    },
    idadhesion(value) {
      console.log("load");
      if (value) {
        this.loadHistory();
      }
    },
  },
  methods: {
    async loadHistory() {
      try {
        this.adhesion = null;
        this.paiement = null;
        this.prelevements = [];
        this.actionsHistory = [];
        this.emails = null;
        this.obsolete = false;
        this.tabsState = 0;

        let res = await axios.get("api/recu/history", {
          params: { idadhesion: this.idadhesion },
        });
        this.adhesion = res.data.adhesion;
        this.paiement = res.data.paiement;
        this.prelevements = res.data.prelevements;
        this.actionsHistory = res.data.actions;
        this.emails = res.data.emails;

        if (this.isMultiplePrelevement) {
          this.actionsHistory.forEach((item) => {
            if (!item.idprelevement) {
              this.obsolete = true;
            }
          });

          for (let ijk = 0; ijk < this.prelevements.length; ijk++) {
            if (
              moment(this.trimestreStart).isSame(
                moment(this.prelevements[ijk].trimester_start)
              )
            ) {
              this.tabsState = ijk;
            }
          }
        }
      } catch (err) {
        this.launchEpicmaxToast(
          "Erreur lors de la récupération de l'historique des actions"
        );
      }
    },
    async openNewTab() {
      try {
        let url = await this.getReceiptUrl("print");
        window.open(url, "_blank");
        this.ok();
      } catch (err) {}
    },
    async downloadReceipt() {
      try {
        let url = await this.getReceiptUrl("download");
        this.downloadItem(url, "Reçu d’adhésion");
        this.ok();
      } catch (err) {}
    },
    downloadItem(url, name) {
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = name;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
    async displayReceipt() {
      if (!this.pdfurl) {
        let url = await this.getReceiptUrl("display");
        this.pdfurl = url;
      } else {
        this.displayPdf = true;
      }
    },
    async getReceiptUrl(method) {
      try {
        this.disableActions = true;
        let idprelevement = null;
        if (this.isMultiplePrelevement && this.prelevements[this.tabsState]) {
          idprelevement = this.prelevements[this.tabsState].idprelevement;
        }
        let res = await axios.get("/api/recu/pdf", {
          params: {
            idadhesion: this.idadhesion,
            method: method,
            idprelevement: idprelevement,
          },
        });
        this.disableActions = false;
        return res.data;
      } catch (err) {
        let status = err.response.status;
        let data = err.response.data;
        if (status === 404) {
          this.launchEpicmaxToast(
            "Adhésion non trouvée, aucun email n'a été envoyé"
          );
          this.cancel();
          this.disableActions = false;
          throw "adhesion non trouvée";
        } else if (data === "infos incompletes") {
          this.launchEpicmaxToast(
            "Les informations de paiements sont incomplétes, aucun email n'a été envoyé"
          );
          this.disableActions = false;
          this.cancel();
          throw "info incomplétes";
        } else {
          console.log(err);
          this.launchEpicmaxToast("Erreur lors de la récupération du reçu");
          this.disableActions = false;
          this.cancel();
          throw "erreur";
        }
      }
    },
    async sendByEmail() {
      try {
        this.disableActions = true;
        let idprelevement = null;
        if (this.isMultiplePrelevement && this.prelevements[this.tabsState]) {
          idprelevement = this.prelevements[this.tabsState].idprelevement;
        }
        await axios.get("/api/recu/send-by-email", {
          params: {
            idadhesion: this.idadhesion,
            idprelevement: idprelevement,
          },
        });
        this.launchEpicmaxToast("Reçu envoyé");
        this.loadHistory();
        this.ok();
      } catch (err) {
        let status = err.response.status;
        let data = err.response.data;
        if (status === 404) {
          this.launchEpicmaxToast(
            "Adhésion non trouvée, aucun email n'a été envoyé"
          );
          this.cancel();
        } else if (status === 403) {
          this.launchEpicmaxToast("Limite de un email par jour");
          this.cancel();
        } else if (data === "no email") {
          this.launchEpicmaxToast(
            "Aucun email n'a été trouvé pour cette entreprise, aucun email n'a été envoyé"
          );
          this.cancel();
        } else if (data === "infos incompletes") {
          this.launchEpicmaxToast(
            "Les informations de paiements sont incomplétes, aucun email n'a été envoyé"
          );
          this.cancel();
        } else {
          this.launchEpicmaxToast(
            "Erreur lors de l'envoi du reçu, vérifier la boite d'envoi de l'adresse de contact"
          );
          this.cancel();
        }
      }
    },
    close() {
      this.disableActions = false;
      this.valueProxy = false;
    },
    cancel() {
      this.close();
      this.$emit("cancel");
    },
    ok() {
      this.close();
      this.$emit("ok");
    },
    listenKeyUp(e) {
      if (e.code === "Escape" && !this.noEscDismiss) {
        this.cancel();
      }
    },
    checkOutside(e) {
      if (!this.noOutsideDismiss) {
        let modal;
        e.target.childNodes.forEach((node) => {
          if (node.classList && node.classList.contains("dismiss-modal")) {
            modal = node;
          }
        });
        if (modal && !this.disableActions) {
          this.cancel();
        }
      }
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style scoped>
.modal-drop-recu {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}
.modal-container {
  box-shadow: $widget-box-shadow;
  z-index: 1001;
  position: relative;
  margin: auto;
}
.solid {
  border: 2px solid #4ab2e3;
  border-radius: 25px;
  position: relative;
}
.solid:hover {
  cursor: pointer;
  background: #e5f5fa;
}
.fullsize {
  width: 100%;
  height: 95%;
}
.center-icon {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.setheight {
  height: 60vh;
}
.actions-container {
  overflow: auto;
  direction: rtl;
}
</style>
